module.exports = __webpack_public_path__ + "img/20190710164404QQ截图20190709232947.9a7c12ab.png";